import styled from 'styled-components';

const StyledSliderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 100%;
`;

const StyledSliderContent = styled.div`
  position: relative;
  height: 2px;
  background-color: #697c91;
  width: 100%;
  margin-right: 20px;
`;

type SliderItemProps = {
  left?: number;
  color?: string;
};

const StyledSliderTick = styled.div<SliderItemProps>`
  position: absolute;
  top: 2em;
  min-width: 50px;
  text-align: center;
  font-size: 8px;
  left: ${(props) => `calc(${props.left}% - 25px)`};

  &:before {
    content: '';
    display: inline-block;
    height: 2em;
    width: 1px;
    position: absolute;
    top: -2.4em;
    left: 50%;
    background-color: #697c91;
  }
`;

const StyledSliderHandle = styled.div<SliderItemProps>`
  position: absolute;
  height: 1em;
  z-index: 1;
  width: 1em;
  border: 2px solid #fff;
  border-radius: 50%;
  top: -5px;
  background: #fff;
  box-shadow: 0 0 6px 2px rgb(0 0 0 / 20%);
  left: ${(props) => `calc(${props.left}% - 5px)`};
  background-color: ${(props) => props.color};
`;
export {
  StyledSliderWrapper,
  StyledSliderContent,
  StyledSliderTick,
  StyledSliderHandle
};
